import "./Hero.css";
import { Link } from "react-router-dom";
import heroVideo from "../../assets/videos/hero.mp4";
const Hero = () => {
  return (
    <section className="hero">
      {/* Background Video */}
      <video className="hero__video" autoPlay muted loop playsInline>
        <source src={heroVideo} type="video/mp4" />
      </video>

      {/* Dark Overlay */}
      <div className="hero__overlay"></div>

      <div className="container hero__container">
        {/* LEFT */}

        <div className="hero__content">
          <span className="hero__tag">
            INDIA'S TRUSTED SPORTS INFRASTRUCTURE COMPANY
          </span>

          <h1>
            Building
            <span> World-Class </span>
            Sports Facilities
          </h1>

          <p>
            We design and construct International-Standard premium Basketball
            Courts, Tennis Courts, Football Field, Pickleball Court, Box
            Cricket, Squash Court, Running Tracks, Synthetic Turf, EPDM Flooring
            and Multi-Purpose Sports Infrastructure across India.
          </p>

          <div className="hero__buttons">
            {/* <button className="primaryBtn">Get Free Quote</button> */}
            <Link to="/contact" className="primaryBtn">
              Get Free Quote
            </Link>
            {/* <button
            
            className="project-btn"
          >View Projects</button> */}

            <Link to="/projects" className="view-projects-btn">
              View All Projects →
            </Link>
          </div>
        </div>

        {/* RIGHT */}

        <div className="hero__stats">
          <div className="statCard">
            <span className="statNumber">10000+</span>

            <span className="statTitle">
              Projects Completed & Every day brings more
            </span>
          </div>

          <div className="statCard">
            <span className="statNumber">15+</span>

            <span className="statTitle">Years Experience</span>
          </div>

          <div className="statCard">
            <span className="statNumber">100%</span>

            <span className="statTitle">Client Satisfaction</span>
          </div>
        </div>
      </div>

      <div className="scrollIndicator">Scroll Down</div>
    </section>
  );
};

export default Hero;
